export default {
    userTasks: [],
    userTasksLoading: false,
    userTaskStatuses: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        userTaskStatus: 20,
        responsibleUser: null
    }
}